import * as $ from "jquery"
import * as _ from "lodash";
import * as moment from "moment";
import Cookies from "js-cookie";
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';

import { Analytics } from "./analytics";
import * as SmartDrawings from "../smartDrawings";
import { ViewerUtils } from "./viewerUtils";

export namespace UiUtils {

    const DATETIME_FORMAT = "DD.MM.YYYY HH:mm";

    const notyf = new Notyf({
        duration: 3000,
        dismissible: true,
        types: [
            {
                type: "warning",
                background: "orange",
                icon: false
            }
        ]
    });
    
    interface ButtonOptions {
        id: string;
        tooltip?: string;
        iconClass?: string;
        onClick?: () => void;
    }

    export function createButton(options: ButtonOptions) {
        const button = new Autodesk.Viewing.UI.Button(options.id);
        if (options.tooltip) {
            button.setToolTip(options.tooltip);
        }
        if (options.iconClass) {
            button.setIcon(options.iconClass);
        }
        button.onClick = () => {
            options.onClick();
            Analytics.sendButtonEvent(options.id);
        }
        return button;
    }

    export function setButtonEnabled(button: Autodesk.Viewing.UI.Button, enabled: boolean) {
        button.setState(enabled ? Autodesk.Viewing.UI.Button.State.INACTIVE : Autodesk.Viewing.UI.Button.State.DISABLED);
    }

    export function createComboButton(options: ButtonOptions): Autodesk.Viewing.UI.ComboButton {
        const button = new Autodesk.Viewing.UI.ComboButton(options.id);
        if (options.tooltip) {
            button.setToolTip(options.tooltip);
        }
        if (options.iconClass) {
            button.setIcon(options.iconClass);
        }
        return button;
    }

    function escape(id: string): string {
        return id.replace(".", "\\.");
    }

    export function hideUiElement(id: string) {
        $(`#${escape(id)}`).addClass("d-none");
    }

    export function showUiElement(id: string) {
        const el = $(`#${escape(id)}`);
        el.removeClass("d-none");
        el.parent().removeClass("d-none");
        if (_.startsWith(id, "toolbar-")) {
            showUiElementByIdPrefix(id);
        }
    }

    export function hideUiElementByClass(className: string) {
        $(`.${className}`).addClass("d-none");
    }

    export function showUiElementByClass(className: string) {
        const el = $(`.${className}`);
        el.removeClass("d-none");
        el.children().removeClass("d-none");
    }

    export function hideUiElementByIdPrefix(idPrefix: string) {
        $(`[id^=${idPrefix}]`).addClass("d-none");
    }

    export function showUiElementByIdPrefix(idPrefix: string) {
        const el = $(`[id^=${idPrefix}]`);
        el.removeClass("d-none");
        el.children().removeClass("d-none");
    }

    export function setUiElementStyle(id: string, styleProperty: string, style: string, priority: string = null) {
        const el = document.getElementById(id);
        el.style.setProperty("display", style, priority);
    }

    export function setNotice({ viewParameters }: SmartDrawings.ModelBase) {
        const { notice } = viewParameters;
        const view = $("#forge-viewport");
        if (notice) {
            view.addClass("notice-overlay");
            let levelClass = null;
            switch (notice.level) {
                case SmartDrawings.NoticeLevel.Error:
                    levelClass = "error";
                    break;
                case SmartDrawings.NoticeLevel.Warning:
                    levelClass = "warning";
                    break;
                default:
                    break;
            }

            if (levelClass != null) {
                view.addClass(levelClass);
            }
            view.attr("data-warning", notice.message);
        }
        else
            view.removeClass("notice-overlay");
    }

    export function areCookiesConsented() {
        try {
            // This will fail in sandboxed iframes.
            const consentCookie = Cookies.get(".AspNet.Consent");
            return consentCookie === "yes";
        } catch (e) {
            return false;
        }
    }

    export function revokeCookieConsent() {
        Cookies.remove(".AspNet.Consent");
    }

    export function notifySuccess(msg) {
        return notyf.success(msg);
    }

    export function notifyError(msg) {
        return notyf.error(msg);
    }

    export function notifyWarning(msg: string) {
        return notyf.open({
            type: "warning",
            message: msg,
            duration: 3000
        });
    }

    export function dismissNotifications() {
        notyf.dismissAll();
    }

    export function dismissNotification(notification) {
        notyf.dismiss(notification);
    }

    export function formatDateTime(str: string) {
        return moment(str).format(DATETIME_FORMAT);
    }

    /**
    * If viewing obsolete revision show link to current.
    */
    export function setRevisionLink(viewerOptions) {
        if (viewerOptions.latestVersionQueryId != null) {
            $("#revision-link").replaceWith(`<li class="nav-item"><a class="nav-link"href="${ViewerUtils.baseUrl().split("/").slice(0, -1).join("/")}/${viewerOptions.latestVersionQueryId}${location.search}"><span class="icon ion-md-warning"</span> Latest revision</a></li>`);
        }
    }

    /**
     * Original model file download.
     */
    export function setDownloadLink(viewerOptions) {
        if (viewerOptions.modelId != null && viewerOptions.modelId != "default") {
            const url = `${ViewerUtils.baseUrl().replace("sd", "sd/download")}/${_.toLower(viewerOptions.type) === "pdf" ? "0" : viewerOptions.modelId}.${_.toLower(viewerOptions.type)}`;
            $("#download-link")
                .replaceWith(
                    `<li class="nav-item file-item"><a class="nav-link" href="${url}" download><span class="icon ion-md-download"></span>DOWNLOAD</a ></li>`);
        }
    }

    /**
     * Set model name to navbar and project + model name to page title if wanted.
     */
    export function setModelName(viewerOptions) {
        if (viewerOptions.displayName && viewerOptions.modelName != null) {
            $("#model-name").text(viewerOptions.modelName);
        }
        if (viewerOptions.displayTitle) {
            document.title = `${viewerOptions.projectName} ${viewerOptions.modelName}`;
        }
    }

    export function addLoader() {
        $(".canvas-wrap").addClass("sd-loader-overlay");
        $(".adsk-viewing-viewer").append("<div class='sd-loader'><span>SMART</span><span style='color: white;'>DRAWINGS</span></div>");
    }

    export function removeLoader() {
        $(".canvas-wrap").removeClass("sd-loader-overlay");
        $(".sd-loader").remove();
    }
}